import React, { useEffect, useState } from "react";
import EventEmitter from "event-lite";

const emitter = new EventEmitter();

export function reRender() {
  emitter.emit("setRenderValue", Date.now());
}

export function useReRender() {
  const [renderValue, setRenderValue] = useState(Date.now());

  useEffect(() => {
    emitter.on("setRenderValue", setRenderValue);
    return () => {
      emitter.off("setRenderValue", setRenderValue);
    };
  }, [setRenderValue]);

  return renderValue;
}

/**
 * Purpose: be able to externally control when a component re-renders.
 */
function EventedRender({ children }) {
  const key = useReRender();
  return <React.Fragment key={key}>{children}</React.Fragment>;
}

export default EventedRender;
